import React, { useState, useEffect, useRef } from "react";
import axios from "../../../../api/axios";
import { Button, Tooltip } from "@mui/material";
import { Typography } from "@mui/material";
import Divider from "@mui/material/Divider";
import { url } from "../../../../configlink";
import TaskIcon from "@mui/icons-material/Task";

import {
  DataGrid,
  GridActionsCellItem,
} from "@mui/x-data-grid";

import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

export default function DropboxCorporates() {

  const [dropboxCorporatesData, setDropboxCorporatesData] = useState([]);

  let loc = useLocation();

  let [dCorpId, setDCorpId] = useState('')
	let adminUser = useSelector((state) => state.userAdmin.userAdmin)
	
  useEffect(() => {
    let data = loc.search.split("=")[1];
    console.log(data);
    setDCorpId(data)
    getDropboxCorps(data);
  }, []);

  async function getDropboxCorps(x) {
    try {
      const response = await axios.get(
        `${url}/api/admin/get_dropbox_corporates`,
        {
          params: {
            id: x,
          },
			withCredentials: true,
			headers: {
				'acgt-admin': adminUser
			},
        }
      );
      console.log(response.data.result);

      setDropboxCorporatesData(response.data.result)
    } catch (error) {
      console.error(error);
    }
  }


  const handleEditClick2 = (cname, id) => {
    console.log(id);

    let conf = window.confirm(`Change Dropbox Status for ${cname}?`)

    if(conf){
        try {
          fetch(`${url}/api/admin/changeDropboxCorporateStatus?id=${id}`,{
                  method:"PUT",
                  headers:{
						"Content-Type": "application/json",
						'acgt-admin': adminUser
                  },
                  credentials: 'include',
              }
          )
          .then((res) => res.json())
          .then((data) => {
              console.log(data);   
              if(data.message === 'success'){
                  alert("Updated successfully")  
                  getDropboxCorps(dCorpId)              
              }                 
          })
          .catch(err => {
              console.error(err);  
          })
      } catch (error) {
          console.error(error);
      }
    }
  };


  const columns = [
    { 
      field: "id", 
      headerName: "id", 
      type: "number", 
      hide: true 
    },
    {
      field: "CorporateId",
      headerName: "Corporate ID",
      type: "string",
      width: 150,
      editable: false,
      // cellClassName: (params) => params.row.Activate === 0 ? "cell-error" : "",
    },
    {
      field: "CorporateName",
      headerName: "Corporate Name",
      type: "string",
      // width: 220,
      flex:1,
      editable: false,
      // cellClassName: (params) => params.row.Activate === 0 ? "cell-error" : "",
    },
    {
      field: "Activate",
      headerName: "Status",
      type: "string",
      width: 130,
      editable: false,
      // cellClassName: (params) => params.row.Activate === 0 ? "cell-error" : "",
      valueGetter: (params) => params.value === 1? 'Active':'Inactive',
      renderCell: (params) => (
          params.value === "Active" ? 
          <span className="text-green-500 font-bold">{params.value}</span>
          :
          <span className="">{params.value}</span>
        )
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      width: 100,
      // cellClassName: (params) => params.row.Activate === 0 ? "cell-error" : "",
      getActions: ({id, row: {CorporateName}}) => {
        return [
          <GridActionsCellItem
            icon={
              <Tooltip title='Change Status'>
                <TaskIcon />
              </Tooltip>}
            label="Edit"
            className="textPrimary"
            key={id}
            onClick={() => handleEditClick2(CorporateName, id)}
            color="inherit"
          />
          // ,
          // <GridActionsCellItem
          //   icon={<CancelIcon />}
          //   label="Cancel"
          //   className="textPrimary"
          //   key={id}
          //   // onClick={handleEditClick(id)}
          //   color="inherit"
          // />,
        ];
      },
    },
  ];


  let [showAddCorporate, setShowAddCorporate] = useState(false)
  let [companyData, setCompanyData] = useState(false)

  const getCompanyDrpDown = async () => {
          try {
            const response = await axios.get(
              `${url}/api/admin/get_corporate_lists`, {
                withCredentials: true,
              }
            );
      
          //   console.log(response.data);
  
          let sortedData = response.data.sort((a,b) => {
              if (a.CorporateName.toLowerCase() < b.CorporateName.toLowerCase()) return -1; 
              if (a.CorporateName.toLowerCase() > b.CorporateName.toLowerCase()) return 1;  
              return 0; 
          })
          // console.log("sorted",sortedData);
      
            setCompanyData(sortedData);
            setShowAddCorporate(true)
          } catch (error) {
            console.error(error);
          }
        };


  function addCorp(x) {

    const exists = dropboxCorporatesData.some(
      item => Number(item.CorporateId) === Number(x)
    )

    if(exists){
      alert("This corporate already exists in the list")
    }
    else {
      // alert("PASS")
      let body2 = {
        corpIdToAdd: x,
        dropboxId: dCorpId
      }
  
      // console.log(body2);
      
      try {
          fetch(`${url}/api/admin/addCorpToDropbox`,{
                  method:"POST",
                  headers:{
						"Content-Type": "application/json",
						'acgt-admin': adminUser
                  },
                  credentials: 'include',
                  body: JSON.stringify(body2)
              },
          )
          .then((res) => res.json())
          .then((data) => {
              // console.log(data);   
              if(data.message === 'success'){
                  alert("Inserted successfully") 
                  document.getElementById('tmpCorp').value = ''
                  setShowAddCorporate(false) 
                  getDropboxCorps(dCorpId)              
              }                 
          })
          .catch(err => {
              console.error(err);  
          })
      } catch (error) {
          console.error(error);
      }
    }

  }
  
  function inactivateAll(x) {

    
    let conf = window.confirm("Inactivate this dropbox for these corporates?")
    
    if(conf){
      console.log(dropboxCorporatesData);
      let body3 = dropboxCorporatesData.map(item => item.id)

      console.log(body3);
      
       try {
          fetch(`${url}/api/admin/inactivateDropboxForCorps`,{
                  method:"PUT",
                  headers:{
						"Content-Type": "application/json",
						'acgt-admin': adminUser
                  },
                  credentials: 'include',
                  body: JSON.stringify(body3)
              },
          )
          .then((res) => res.json())
          .then((data) => {
              // console.log(data);   
              if(data.message === 'success'){
                  alert("Inactivated all successfully")  
                  getDropboxCorps(dCorpId)              
              }                 
          })
          .catch(err => {
              console.error(err);  
          })
      } catch (error) {
          console.error(error);
      }

    }
    
  }

  return (
    <div>
      <div style={{ height: 400, width: "100%" }}>
        <div className="App">
          <div style={{ paddingTop: 20, display:'flex', justifyContent:'space-around' }}>
            <Typography
              variant="h5"
              style={{
                fontWeight: "bold",
                color: "var(--color-primary-purple)",
              }}
              align="Center"
            >
              Dropbox Corporates
            </Typography>
            <div className="flex gap-[20px]">
              <Button variant="outlined" 
                style={{color:'white', backgroundColor:'var(--color-primary-purple)', border:'none', textTransform: 'none', height:30, fontSize:12 }} 
                onClick={() => {
                  getCompanyDrpDown()
                  }
                } 
                >
                  Add Corporate
                </Button>
              {/* <Button variant="outlined" 
                style={{color:'white', backgroundColor:'#e96b0b', border:'none', textTransform: 'none', height:30, fontSize:12 }} 
                onClick={() => {
                  inactivateAll()
                  }
                } 
                >
                  Inactivate All
                </Button> */}
            </div>
          </div>
          <Divider
            style={{
              marginTop: 10,
              marginBottom: 30,
              marginLeft: 20,
              marginRight: 20,
            }}
          />
          {showAddCorporate && 
          <>
          <div className="w-full flex justify-center">
            <div className='flex items-center gap-[10px]'>
                <select 
                    name="specificCorp"
                    className='w-[300px] h-[35px] border-1'
                    id='tmpCorp'
                >
                  <option value={-1}>Select</option>
                {companyData.map((data, i) => (
                    <option value={data.CorporateId} key={i}>
                        {data.CorporateName}
                    </option>
                    ))}
                </select>
                <button 
                className='bg-[var(--color-primary-purple)] text-white px-2 py-1 rounded-md'
                onClick={() => {
                  let val = document.getElementById('tmpCorp').value
                  console.log(val);
                  if(val === "-1"){
                    alert("Please select Corporate to add")
                  }
                  else {
                    // console.log("Pass");
                    addCorp(val)
                  }
                }}
                >
                  Add</button>
            </div>
        </div>
            <Divider
              style={{
                marginTop: 10,
                marginBottom: 30,
                marginLeft: 20,
                marginRight: 20,
              }}
            />
          </>
          }
          <div className="container2">
            <main className="main2">
              <DataGrid
                initialState={{
                  columns: {
                    columnVisibilityModel: {
                      id: false,
                    },
                  },
                }}
                style={{ width: "100%", height: "95%" }}
                columnHeaderHeight={35}
                rowHeight={40}
                rows={dropboxCorporatesData}
                columns={columns}
                sx={{
                  "& .MuiDataGrid-columnHeaders": {
                    color: "var(--color-primary-purple)",
                  },
                  "& .MuiDataGrid-columnHeaderTitle": {
                    fontWeight: 700,
                  },
                  "& .cell-error": {
                    backgroundColor: "#feacac",
                  }
                }}
              />
            </main>
          </div>
        </div>
      </div>
    </div>
  );
}
